
/**
 * @export
 * @enum {string}
 */
export enum SettingsType {
    WEB = 'WEB',
    MOBILE = 'MOBILE'
}